export default __webpack_public_path__ + "static/media/document.49e6be69.svg";